import Vue from 'vue'
import App from './App.vue'
import {getRouter} from './router'
import store from './store'
import format from "date-fns/format";
import {parseISO} from "date-fns";
import VueMeta from 'vue-meta';
import VueScrollTo from 'vue-scrollto';
import ScrollAnimate from "./directives/scroll-animate";
import {i18n} from "./i18n";
import Vuelidate from 'vuelidate'
import VueMobileDetection from "vue-mobile-detection";

Vue.config.productionTip = true
Vue.use(VueMobileDetection);

Vue.filter('viFormatDate', function (dateTimeString, f) {
  try {
    if (!dateTimeString || !dateTimeString.length) {
      return dateTimeString
    }

    return format(parseISO(dateTimeString), (f || 'MMM d, yyyy'));
  } catch (e) {
    return dateTimeString
  }
});

Vue.prototype.$bubbleUp = function $bubble(eventName, ...args) {
  let component = this;
  do {
    component.$emit(eventName, ...args);
    component = component.$listeners[eventName] ? null:component.$parent;
  } while (component);
};

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})



Vue.directive('scroll-animate', ScrollAnimate)

let width = document.body.clientWidth;
let offsetScroll = -79;
if (width < 1440) {
  offsetScroll = -59;
}

Vue.use(VueScrollTo, {
  container: 'body',
  offset: offsetScroll
});
Vue.use(Vuelidate);

new Vue({
  i18n,
  router: getRouter({store, i18n}),
  store,
  render: h => h(App),

}).$mount('#app')

